import React, { useState } from "react";
import { Button } from "@/aible";
import { isEnabled } from "@/utils/featureFlags";
import { useDispatch, useSelector } from "@/types/store";
import { handleSelectUseCase } from "@/containers/ChatGPT/reducer";
import { updateAgentAutonomyView } from "@/containers/View/reducer";
import { getCorpus } from "@/containers/LanguageModelArtifact/reducer";
import { CorpusUrlModal } from "@/components/Tiles/Sense/CorpusTile";
import UploadDocument from "@/components/LanguageModelArtifact/UploadDocument";
const UnstructuredRowHoverActions = ({ artefactId }) => {
    const dispatch = useDispatch();
    const artefact = useSelector((state) => getCorpus(state, artefactId));
    const isNotEmptyDataset = Boolean(artefact?.metadata?.document_list?.length);
    const [isUrlModalOpen, updateIsUrlModalOpen] = useState(false);
    const [isLoadingCorpus, updateIsLoadingCorpus] = useState(false);
    return (React.createElement(React.Fragment, null,
        React.createElement(UploadDocument, { artifactId: artefactId, isSmall: false, style: {
                minWidth: "90px",
                minHeight: "40px",
                padding: "9px 14px",
                marginRight: "10px"
            }, onStart: () => {
                updateIsLoadingCorpus(true);
            }, onComplete: () => {
                updateIsLoadingCorpus(false);
            } }),
        isEnabled("chat-aible") && (React.createElement(React.Fragment, null,
            isEnabled("chat-aible-document-summarization-url") && (React.createElement(Button, { type: "Secondary", isLoading: false, onClick: (e) => {
                    e.stopPropagation();
                    updateIsUrlModalOpen(true);
                } }, "Add URLs")),
            isNotEmptyDataset && (React.createElement(Button, { type: "Secondary", isLoading: false, onClick: (e) => {
                    e.stopPropagation();
                    if (isEnabled("agent-autonomy-controls")) {
                        dispatch(updateAgentAutonomyView("RECOMMENDED"));
                    }
                    dispatch(handleSelectUseCase("CHATAIBLE_DOCUMENT_SUMMARIZATION", artefactId));
                } }, "Document Summarization Chat")))),
        React.createElement(CorpusUrlModal, { corpusId: artefactId, isOpen: isUrlModalOpen, updateIsOpen: updateIsUrlModalOpen, updateIsLoadingCorpus: updateIsLoadingCorpus })));
};
export default UnstructuredRowHoverActions;
